export const Logo = ({ light = false, compact = false, size = 44 }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
    <img src="/logo-sm.png" alt="Logo Conciergerie Familly 29" width={size} height={size}
      className={`shrink-0 rounded-full bg-white ${light ? "ring-2 ring-white/20" : "ring-1 ring-[#0F2840]/10"}`} style={{ width: size, height: size }} />
    {!compact && (
      <span className="leading-none">
        <span className={`block font-display text-lg font-semibold ${light ? "text-white" : "text-[#0F2840]"}`}>
          Familly 29
        </span>
        <span className={`block whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.18em] ${light ? "text-white/70" : "text-slate-500"}`}>
          Conciergerie · Brest
        </span>
      </span>
    )}
  </span>
);
